<template>
  <section class="section-banner"><!--.new_design_banner-->
    <Slick ref="bannerSlick"  :options="landingBanner" :class=" isRTL ? 'ltr' : 'ltr'">
      {{BannersImage}}
      <!-- <div v-if="BannersImage.length == 0" v-for="(b , key) in 5" :key="key"> -->
      <div v-if="BannersImage.length == 0 " v-for="(b , key) in 1" :key="key">
        <div class="bannerContainer" >
          <!-- <img src="@/assets/img/bharat_1280_720.jpg" class alt> -->
          <!-- <img v-if="project == 'ticketak'" src="@/assets/img/ticketak_banner1.jpg" class alt /> -->

          <!--img

            src="@/assets/img/White_Background_Logo.png"
            class="p-3 w-50"
            alt

          /-->
          <img
            v-if="project == 'ticketak' && false"
            src="https://img.ticketak.com/assets/images/movies/banners/5e71f9736d9c9.jpg"
            class
            alt

          />
          <img src="@/assets/img/Cineco-Logo.png" class="logo-banner-img" alt />
          <!--@/assets/img/1920-x-600.jpg--->
        </div>
      </div>

      <!---New Design Banner-->
      <div
        v-if="BannersImage.length > 0 && false"
        v-for="(banner , bannerkey) in BannersImage"
        :key="bannerkey"
        class="row main_body_banner d-flex flex-wrap" style="width:unset">
        <div class="col-xl-6 px-0 col-md-12 col-lg-12 col-sm-12">
          <img :src="banner.banner_img || banner.mobile_banner_img" width="100%" class="banner_img"/>
        </div>
        <div class="col-xl-6 banner_movie_content d-xl-block d-sm-none d-md-none d-lg-none mobile_banner_content">
          <!--Movie Title-->
          <div class="new_banner_title">{{ banner.title }}</div>

          <!--Language/2D-->
          <div class="new_second_line mb-2">
            <div class="grade_banner" v-if="banner.rated">
              <span>{{ banner.rated }}</span>
            </div>
            <span class="banner_lang" v-if="banner.lang">{{ banner.lang }}</span>

            <div class="display_banner">
              <span>{{ banner.format || '2D' }}</span>
            </div>
          </div>

          <!--Movie Detail-->
          <div class="movie_detail_banner" v-if="banner.plot">
            <h6 >
              {{ banner.plot }}
            </h6>
          </div>

          <!--Imd Rating-->
          <div class="banner_rating mb-4" v-if="banner.IMDBRating || banner.rating">
            <span v-if="banner.IMDBRating">IMDb</span>
            <span v-if="!banner.IMDBRating && banner.rating">Rating</span>
            <span>{{ banner.IMDBRating || banner.rating }}</span>
          </div>

          <!--Time/Date-->
          <div class="banner_time mt-2 pt-2 mb-4" v-if="banner.release">

          <span class="ban_date" v-if="banner.release">
            <img src="@/assets/img/icons/date.png" class="ban_img"/>
            <span>{{ banner.release }}</span>
          </span>
            <span class="ban_time">

            <img src="@/assets/img/icons/clock.png" v-if="banner.runtime" class="ban_img"/>
            <span v-if="banner.runtime">{{ banner.runtime }}</span>
          </span>
          </div>

          <!--Book Now btn---->
          <div>
            <router-link to v-on:click.native="navigateRoute(banner)">
              <button class="main_btn mt-5">
                <img class="pt-1" src="@/assets/img/icons/book_now.svg"/>
                <span class="pr-1">{{$t("BOOK_NOW")}}</span>
              </button>
            </router-link>
          </div>
        </div>
      </div>
      <!---End-->

  <div
        v-if="BannersImage.length > 0"
        v-for="(banner , bannerkey) in BannersImage"
        :key="bannerkey"
        class="row margin-small"
      >
        <div class="bannerContainer">
          <!-- <img src="@/assets/img/bharat_1280_720.jpg" class alt> -->
          <!-- :to="{ name: 'movie', params: { movieID: banner.id,cinemaID:'0' }}"> -->

          <router-link to v-on:click.native="navigateRoute(banner)">
            <img :src="banner.banner_img" class alt />

            <div
              v-if="banner.banner_url !== 'Refferal Offer' && banner.banner_url != 'Register Offer'"
              class="filterbox"
              :class="(banner.movie) ? '' : 'disable-filter'"
            >
              <div class="bannerContent">
                <div v-if="banner.movie" class="w-75 pr-2">
                  <div class="bannerTitle">{{ banner.title }}</div>
                  <div class="details">
                    <span>{{ banner.lang }}</span>
                    <span>|</span>
                    <span>{{ banner.runtime }}</span>
                    <span>|</span>
                    <span>{{banner.rated}}</span>
                  </div>
                </div>
                <div v-else>
                  <div class="bannerTitle">{{ banner.title }}</div>
                  <div class="details">
                    <span>{{ banner.subtitle }}</span>
                  </div>
                </div>
                <div class="w-25"></div>
              </div>
            </div>
          </router-link>
        </div>
      </div>

      <!-- <div>
        <div class="bannerContainer">
          <router-link to v-on:click.native="redeemvoucher">
            <img
              src="https://img.ticketak.com/assets/images/movies/banners/5e81ca8316f15.jpg"
              class
              alt
            />
          </router-link>
        </div>
      </div>-->
    </Slick>
  </section>
</template>

<script>
import Slick from "vue-slick";
import { makeRequest } from "@/helper/internet.js";
import { PROJECT } from "@/helper/constant.js";
import { isMobile, isIOS, isAndroid } from "mobile-device-detect";
import {mapGetters} from 'vuex'

export default {
  name: "landingBanner",
  props: {
    bannerName: {
      type: String,
      default: ""
    },
    bannerList: {
      type: Array,
      default: []
    }
  },

  components: {
    Slick
  },
  data() {
    return {
      userDetails: {},
      project: PROJECT,
      isMobile: isMobile,
      BannersImage: [],
      landingBanner: {
        initialSlide: 0,
        dots: true,
        arrows: true,
        autoplay: true,
        loop: true,
        infinite: true,
        slidesToShow: 1,
        centerMode: true,
        slidesToScroll: 1,
        autoplaySpeed: 3500,
        centerPadding: "5%",
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              centerMode: false
            }
          }
        ]
      }
    };
  },
  watch: {
    bannerList: function(newValue, oldValue) {
      this.BannersImage = newValue;
      this.$refs.bannerSlick.destroy();
      this.$nextTick(() => {
        this.$refs.bannerSlick.create();
        this.$refs.bannerSlick.goTo(0, true);
      });
    }
  },
    computed: {
    ...mapGetters(['isRTL']),
  },
  mounted() {
    // this.getallShows();
    // this.BannersImage = this.bannerList;
  },
  methods: {
    navigateRoute: function(banner) {
      if (banner.movie == false) {
        if (banner.banner_url == "Refferal Offer") {
          this.$root.$emit("bv::show::modal", "shareModal");
        } else if (banner.banner_url == "Register Offer") {
          this.$root.$emit("bv::show::modal", "signUp");
        } else if (banner.banner_url == "https://www.mytiketi.com") {
          if (isMobile) {
            if (isAndroid) {
              window.open(
                "https://play.google.com/store/apps/details?id=com.mytiketi.mytiketi"
              );
            } else if (isIOS) {
              window.open(
                "https://apps.apple.com/in/app/mytiketi/id1475621585"
              );
            }
          } else {
            window.open(
              "https://play.google.com/store/apps/details?id=com.mytiketi.mytiketi"
            );
          }
        } else if (banner.banner_url == "https://www.mytiketi.com/promotion") {
          window.location.href = "https://www.mytiketi.com/promotion";
        } else if (banner.banner.BannerType == "Static") {
          window.location.href = banner.banner.TargetUrl;
        }
      } else {
        this.$router.push({
          name: "movie",
          params: { movieID: banner.id, cinemaID: "0" }
        });
      }
    },
    getallShows: function() {
      let payload = {};
      makeRequest("/GetAllShow", "POST", null, payload).then(response => {
        const { error, res } = response;
        this.BannersImage = res.data.Banners;
        this.ShowImage = res.data.show;
        this.$refs.bannerSlick.destroy();
        this.$nextTick(() => {
          this.$refs.bannerSlick.create();
          this.$refs.bannerSlick.goTo(1, true);
        });
      });
    }
  }
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/partials/mainBanner.vue